let apiUrl = process.env.VUE_APP_API_URL;


class DoorApi {

    getListByFloorPlanId(id){
        var url = apiUrl + `doors?floorPlanId=${id}&limit=100&page=1`;
        return api.call('get', url)
            .then(({ data }) => {
                return data
            });

    }

    getList() {
        var url = apiUrl + 'doors';
        return api.call('get', url)
            .then(({ data }) => {
                return data
            });
    }


    get(id) {
        var url = apiUrl + 'doors/';
        return api.call('get', url + id)
            .then(({ data }) => {
                return data
            });
    }
 
    create(data) {
        var url = apiUrl + 'doors';
        return api.call('post', url, data)
            .then(({ data }) => {
                return data
            });

    }
    update(data, payload) {
        var url = apiUrl + 'doors/';
        return api.call('patch', url + data._id, payload)
            .then(({ data }) => {
                return data
            });
    }
    delete(id) {
        var url = apiUrl + 'doors/';
        return api.call('delete', url + id)
            .then(({ data }) => {
                return data
            });
    }

}

export default DoorApi;